module.exports = __webpack_public_path__ + "assets/9728146b6f6cfee57a4c80fc5209bd87.png";